module.exports = __webpack_public_path__ + "static/media/rvnotificationOff.4a3ece66.svg";